import { z } from "zod";

/**
 * Optional purchase record shape (e.g. analytics or future receipts)
 */
export const PurchaseInfoSchema = z.object({
  /** Email associated with the purchase */
  email: z.email().optional().describe("Email address for the purchase"),

  /** Date of the purchase */
  date: z.date().optional().describe("When the purchase was made"),

  /** Location where purchase was made */
  location: z.string().optional().describe("Geographic location of purchase"),

  /** Unique transaction identifier */
  transactionID: z.string().optional().describe("Unique transaction ID from payment processor"),

  /** Purchase amount in currency */
  amount: z.number().min(0).optional().describe("Purchase amount"),
});

export type PurchaseInfo = z.infer<typeof PurchaseInfoSchema>;
